import '../../../lib/assets/javascripts/swipe';
import '../application/components/swipe_carousel.coffee';

import '../application/about/learning_success.js';
import '../application/about/press.coffee';
import '../application/about/use_cases.coffee';
import '../application/about/about.sass';

import '../application/about/press.sass';
// import '../application/about/fibs_study_progress_circles.js';
import '../application/about/fibs_study_progress_bar.js';

